import React from 'react';
import Section from "./Section.js";
import { connect } from "react-redux";
import MyButton from "./MyButton";
import { Grid, Typography, } from '@material-ui/core';
import Link from "./Link";

const mapStateToProps = (state, ownProps) => {
  return ({
    serializedState: JSON.stringify(state),
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const About = props => {
  const Lang = props.lang.About;
  return (
    <Section id="About" header={Lang.header}>
      <Typography>{Lang.about_info}</Typography>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}>
          <Link url="http://flap.org" text={Lang.visit_site}/>
        </Grid>
        <Grid item xs={4}>
          <Link url="https://birdsafe.ca/ways-to-give/" text={Lang.give}/>
        </Grid>
        {
          // I could add a link to the android version I guess...
          // "https://play.google.com/store/apps/details?id=appinventor.ai_andrewtfryer.FLAP_App"
        }
        <Grid item xs={4}>
          <MyButton variant="contained" onClick={() => {
            // TODO: think of a better way to report a bug!
              /*
              window.open(
                "mailto:appdeleveloper1212@gmail.com"
                + "?subject=FLAP App Bug Report"
                + "&body=Hi,\nMy Problem is ...\nHere is the state of te application:" 
                + this.props.serializedState
              )
              */
              window.open("mailto:appdeveloper1212@gmail.com")
              console.log(props.serializedState);
            }}>
            {Lang.report_a_bug}
          </MyButton>
        </Grid>
      </Grid>
    </Section>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(About);



// WEBPACK FOOTER //
// ./src/pages/About.js